import { initLiff } from "./liff-init";
import { register, start, navigate } from "./router";
import { renderHome } from "./pages/home";
import { renderBooking } from "./pages/booking";
import { renderPlaceholder } from "./pages/placeholder";
import { hideLoader, showToast } from "./ui";

async function bootstrap(): Promise<void> {
  try {
    await initLiff();
  } catch (err) {
    console.error("[liff] init failed:", err);
    showToast("LIFF 初始化失敗,以離線模式繼續", "error");
  }

  register("home", () => renderHome());
  register("booking", () => renderBooking());
  register("herbs", () => renderPlaceholder("herbs"));
  register("map", () => renderPlaceholder("map"));
  register("events", () => renderPlaceholder("events"));
  register("restaurant", () => renderPlaceholder("restaurant"));

  // Deep link via liff.state (LINE redirects with this param when URL is
  // https://liff.line.me/{LIFF_ID}?liff.state=<value>)
  const liffState = new URLSearchParams(location.search).get("liff.state");
  if (liffState && !location.hash) {
    const target = liffState.startsWith("#") ? liffState.slice(1) : liffState.replace(/^\/+/, "");
    if (target) navigate(target);
  }

  // Default route on first load
  if (!location.hash) navigate("home");

  start();
  hideLoader();
}

void bootstrap();
